// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-content[data-v-57c0cf15] {
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.label-content .content[data-v-57c0cf15] {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.label-content .content > div[data-v-57c0cf15] {
  flex: 1;
  width: 100%;
}
.label-content .content .top[data-v-57c0cf15] {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/EnterpriseQuota/QuotaList.vue","webpack://./QuotaList.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ACAF;ADLA;EAOI,WAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;ACCJ;ADdA;EAeM,OAAA;EACA,WAAA;ACEN;ADlBA;EAmBM,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,SAAA;ACEN","sourcesContent":["\n.label-content {\n  height: 600px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  .content {\n    width: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 10px;\n    > div {\n      flex: 1;\n      width: 100%;\n    }\n    .top {\n      display: flex;\n      justify-content: flex-start;\n      align-items: flex-start;\n      gap: 10px;\n    }\n  }\n}\n",".label-content {\n  height: 600px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.label-content .content {\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n}\n.label-content .content > div {\n  flex: 1;\n  width: 100%;\n}\n.label-content .content .top {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
